import ky from "../lib/ky";

export default ky.extend({
  // https://github.com/sindresorhus/ky#retry
  retry: 2,
  // https://github.com/sindresorhus/ky#timeout
  timeout: 30000,
  // set default request headers
  headers: {
    Accept: "application/json"
  }
});
